import { motion } from "framer-motion";
import { useStats } from "../hooks/useStats";
import { useT } from "../lib/prefs";

export const SeatCounter = ({ compact = false }) => {
  const t = useT();
  const stats = useStats();
  if (!stats) return null;
  const booked = stats?.booked ?? 0;
  const total = stats?.total ?? 100;
  const remaining = stats?.remaining ?? total - booked;
  const pct = Math.min(100, (booked / total) * 100);

  return (
    <div data-testid={compact ? "seat-counter-compact" : "seat-counter"} className={compact ? "" : "glass rounded-2xl p-4 sm:p-5"}>
      <div className="flex items-end justify-between gap-3">
        <div>
          <div className="font-mono text-xs tracking-[0.2em] text-violet-200">{t.seatsLeft}</div>
          <div className="font-display font-black text-white leading-none mt-1">
            <span className="text-4xl sm:text-5xl tabular-nums" data-testid="seat-remaining">{remaining}</span>
            <span className="text-lg text-violet-200/80"> / {total}</span>
          </div>
        </div>
        <span className="flex items-center gap-2 font-mono text-xs text-pink-200 pb-1">
          <span className="w-2 h-2 rounded-full bg-pink-400 animate-pulse" /> {booked} {t.booked}
        </span>
      </div>
      <div className="mt-4 h-2 rounded-full bg-violet-950 overflow-hidden">
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: `${pct}%` }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="h-full rounded-full bg-gradient-to-r from-violet-500 via-fuchsia-500 to-pink-400 shadow-[0_0_14px_rgba(236,72,153,0.7)]"
        />
      </div>
    </div>
  );
};
